import { render, staticRenderFns } from "./singleBanner.vue?vue&type=template&id=6cc30ea4&scoped=true"
import script from "./singleBanner.vue?vue&type=script&lang=js"
export * from "./singleBanner.vue?vue&type=script&lang=js"
import style0 from "./singleBanner.vue?vue&type=style&index=0&id=6cc30ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc30ea4",
  null
  
)

export default component.exports